export const OTHER_CERTIFICATE_OPTIONS = [
  {
    value: "AFP",
    label: "AFP — Associate Financial Planner（財務策劃師）",
  },
  {
    value: "CFP",
    label: "CFP — Certified Financial Planner（認可財務策劃師）",
  },
  {
    value: "CFA",
    label: "CFA — Chartered Financial Analyst（特許金融分析師）",
  },
  {
    value: "CPB",
    label: "CPB — Certified Private Banker（認證私人銀行家）",
  },
  {
    value: "RFP",
    label: "RFP — Registered Financial Planner（註冊財務策劃師）",
  },
];
